// extracted by mini-css-extract-plugin
export default {"component":"Select_component__f+LPs"};